import {
    IonButton,
    IonButtons,
    IonCard,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonContent,
    useIonViewWillEnter,
} from "@ionic/react";
import { addCircleOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { OrganizationSearchBar } from "./OrganizationSearchBar";
import { RootState } from "../../../store/rootReducer";
import { setMaxListAvailableIndex, setPreselectOrganization, setPreselectAll } from "../../../store/userProfileOrganization";
import { selectOrganizationsAvailable } from "../../../store/userProfileOrganization/selectors/selectOrganizationsAvailable";

export const OrganizationSelector = () => {
    const [isInfiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);
    const dispatch = useDispatch();
    const organizations = useSelector(selectOrganizationsAvailable);
    const maxDataList = useSelector((state: RootState) => state.userProfileOrganization.maxListAvailableIndex);
    const state = useSelector((state: RootState) => state.userProfileOrganization)


    // Logica para IonInfiniteScroll
    const pushData = () => {
        dispatch(setMaxListAvailableIndex(maxDataList + 20));
    }

    const loadData = (ev: any) => {
        setTimeout(() => {
            pushData();
            ev.target.complete();
            if (organizations.length === 1000) {
                setInfiniteDisabled(true);
            }
        }, 500);
    }

    useIonViewWillEnter(() => {
        dispatch(setMaxListAvailableIndex(20));
    });

    const handlePreselectAll = async () => {
        dispatch(setPreselectAll(organizations));
    };

    return (
        <IonCard style={{ height: "75vh" }} class="ion-no-margin">
            <IonToolbar>
                <IonTitle size="small" style={{ fontWeight: 500 }}>
                    Disponibles {organizations && <span>({organizations.length})</span>} {/* Según resultado de búsqueda */}
                </IonTitle>
                <IonButtons slot="end">
                    {!!organizations.length && (
                        <IonButton fill="solid" size="small" color="primary" onClick={handlePreselectAll}>
                            <small>Agregar todos</small>
                            <IonIcon icon={addCircleOutline} slot="end" />
                        </IonButton>
                    )}
                </IonButtons>
            </IonToolbar>
            <OrganizationSearchBar /> {/* SearchBar para buscar los clientes que se asignarán al perfil */}
            {/* Listado de clientes filtrados. Para que funcione IonInfiniteScroll es necesario darle altura al IonContent */}
            <IonContent style={{ overflow: "scroll", height: "60vh" }}>
                <IonList>
                    {state.findOrganizationsStatus === "succeeded" && organizations.slice(0, maxDataList).map((item) => (
                        <IonItem key={item.id}>
                            <IonLabel className="ion-hide-md-up" text-wrap>
                                <h5 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{item.name}</IonText>
                                </h5>
                            </IonLabel>
                            <IonLabel className="ion-hide-md-down" text-wrap>
                                <h3 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{item.name}</IonText>
                                </h3>
                            </IonLabel>
                            <IonButton
                                fill="clear"
                                onClick={() => {
                                    dispatch(setPreselectOrganization(item));
                                }}
                                size="default"
                            >
                                <IonIcon icon={addCircleOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                    {state.findOrganizationsStatus === "pending" && (
                        <p className="ion-text-center">
                            <IonSpinner />
                        </p>
                    )}
                </IonList>
                <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={isInfiniteDisabled}>
                    <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargando más datos..." />
                </IonInfiniteScroll>
            </IonContent>
        </IonCard>
    );
};